var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.floatAd&&_vm.floatAd.show),expression:"floatAd&&floatAd.show"}],attrs:{"id":"floatwindow"}},[(_vm.floatAd&&_vm.floatAd.show)?_c('router-link',{attrs:{"to":"/peasantsStrive/notice"}},[_c('img',{attrs:{"src":_vm.floatAd.img,"alt":""}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }